window.PMP_SHIP_DE={"d":495,"v":{}};
/* PMP Versand nach Deutschland (Runde 2, 30.09.2026): Produktseite aus der Tabelle je Variante (Stand der Versandprofile 30.09.2026), Warenkorb live von Shopify. Nur deutsche Sprache. */
(function(){
  if(!/^de/i.test(document.documentElement.lang||'')) return;
  var D=window.PMP_SHIP_DE||{d:495,v:{}};
  function fmt(c){return (c/100).toFixed(2).replace('.',',')+' €';}
  function produkt(){
    var el=document.querySelector('[data-pmp-ship-product]'); if(!el) return;
    var form=el.closest('form')||document;
    var inp=document.querySelector('form[action*="/cart/add"] [name="id"]')||document.querySelector('[name="id"]');
    var last=null;
    function upd(){
      var m=/[?&]variant=(\d+)/.exec(location.search); var id=m?m[1]:(inp&&inp.value); if(id===last) return; last=id;
      var c=D.v[id]; if(c===undefined) c=D.d;
      el.textContent='Versand nach Deutschland: '+fmt(c)+(c>0?', ab 49 € versandfrei':'');
    }
    upd(); setInterval(upd,700);
  }
  /* 03.10.2026: Warenkorb und Drawer zeigen den günstigsten Versand nach Deutschland live von Shopify
     (prepare_shipping_rates, dann async_shipping_rates mit kurzem Nachfragen) und den Gesamtpreis inklusive Versand.
     Nur bei Euro und Markt DE. Bei Fehler, Fremdwährung oder leerer Antwort bleibt beides verborgen, nie ein geschätzter Wert. */
  var lauf=0;
  var Q='shipping_address%5Bcountry%5D=DE&shipping_address%5Bzip%5D=10115';
  var J={headers:{Accept:'application/json'},credentials:'same-origin'};
  function warte(ms){return new Promise(function(ok){setTimeout(ok,ms);});}
  function guenstigste(j){
    var a=j&&j.shipping_rates; if(!a||!a.length) return null;
    var m=null; a.forEach(function(r){var p=parseFloat(r.price); if(!isNaN(p)&&(m===null||p<m)) m=p;}); return m;
  }
  function abholen(n){
    return fetch('/cart/async_shipping_rates.json?'+Q,J)
      .then(function(r){
        if(r.status===202) return {nochmal:true};
        if(!r.ok) return null;
        return r.json().then(function(j){return {m:guenstigste(j)};}).catch(function(){return null;});
      })
      .catch(function(){return null;})
      .then(function(x){
        if(x&&x.nochmal&&n>0) return warte(800).then(function(){return abholen(n-1);});
        if(x&&x.m===null&&n>0) return warte(800).then(function(){return abholen(n-1);});
        return x&&typeof x.m==='number'&&isFinite(x.m)&&x.m>=0?x.m:null;
      });
  }
  /* Nur bei Euro und Markt Deutschland: die Zeile heißt "Versand nach Deutschland". */
  function euroDE(c){
    var land=(window.Shopify&&window.Shopify.country)||'';
    return c&&c.currency==='EUR'&&String(land).toUpperCase()==='DE';
  }
  function geld(cent,cur){
    try{return new Intl.NumberFormat('de-DE',{style:'currency',currency:cur}).format(cent/100);}catch(e){return null;}
  }
  function verbergen(){
    document.querySelectorAll('[data-pmp-ship-row],[data-pmp-ship-total-row],[data-pmp-ship-progress]').forEach(function(e){e.style.display='none';});
  }
  function warenkorb(){
    var rows=document.querySelectorAll('[data-pmp-ship-row]'); if(!rows.length) return;
    var nr=++lauf;
    var vorbereitet=fetch('/cart/prepare_shipping_rates.json?'+Q,{method:'POST',body:'',headers:{Accept:'application/json'},credentials:'same-origin'})
      .then(function(r){return r.ok;}).catch(function(){return false;});
    Promise.all([vorbereitet.then(function(ok){return ok?abholen(5):null;}),fetch('/cart.js',J).then(function(r){return r.ok?r.json():null;}).catch(function(){return null;})])
      .then(function(e){
        if(nr!==lauf) return;
        var m=e[0], c=e[1];
        /* 09.10.2026 Claude: Versandfrei ab 49 € (Deutschland). Shopify misst nach Rabatt (Test 09.10.: 49,99 € minus 10 % = 45,00 € kostet 4,95 €, 66,59 € kostenlos), also total_price. async_shipping_rates kennt den Versandrabatt nicht. */
        var frei=!!c&&typeof c.total_price==='number'&&c.total_price>=4900;
        if(!c||!c.item_count||typeof c.total_price!=='number'||!euroDE(c)||(m===null&&!frei)){verbergen();return;}
        var cent=frei?0:Math.round(m*100);
        var vs=cent===0?'kostenlos':geld(cent,c.currency), gs=geld(c.total_price+cent,c.currency);
        if(!vs||!gs){verbergen();return;}
        document.querySelectorAll('[data-pmp-ship-row]').forEach(function(row){
          var sp=row.querySelectorAll('span');
          if(sp[0]) sp[0].textContent='Versand nach Deutschland';
          if(sp[1]) sp[1].textContent=vs;
          row.style.display='';
          var p=row.nextElementSibling;
          if(!p||!p.hasAttribute('data-pmp-ship-progress')){
            p=document.createElement('p'); p.setAttribute('data-pmp-ship-progress','');
            p.style.cssText='margin:-.2rem 0 .5rem;font-size:.85rem;color:rgb(var(--c-accent-deep))';
            row.parentNode.insertBefore(p,row.nextSibling);
          }
          var rest=frei?null:geld(4900-c.total_price,c.currency);
          if(rest){p.textContent='Noch '+rest+' bis zum kostenlosen Versand'; p.style.display='';}else{p.style.display='none';}
          var t=p.nextElementSibling;
          if(!t||!t.hasAttribute('data-pmp-ship-total-row')){
            t=document.createElement('div'); t.className='cart-summary__row cart-summary__row--total'; t.setAttribute('data-pmp-ship-total-row','');
            t.innerHTML='<span>Gesamt inkl. Versand</span><span></span>';
            p.parentNode.insertBefore(t,p.nextSibling);
          }
          t.lastElementChild.textContent=gs;
          t.style.display='';
        });
      }).catch(verbergen);
  }
  document.addEventListener('DOMContentLoaded',function(){produkt();warenkorb();});
  if(document.readyState!=='loading'){produkt();warenkorb();}
  document.addEventListener('cart:updated',warenkorb);
})();
/* 08.10.2026 Claude: Galeriebild folgt der teeinblue-Farbauswahl (URL-Parameter variant) */
(function(){var last=null;function sync(){var m=/[?&]variant=(\d+)/.exec(location.search);if(!m||m[1]===last)return;last=m[1];var el=document.querySelector('[data-variants-json]');if(!el)return;try{var v=JSON.parse(el.textContent).find(function(x){return String(x.id)===m[1];});if(v&&v.featured_media){var th=document.querySelector('[data-gallery-thumb][data-media-id="'+v.featured_media.id+'"]');if(th)th.click();}}catch(e){}}setInterval(sync,700);})();
